import { Dropdown } from 'react-bootstrap';

import { ActionMenuItem, type Actions } from 'actions';
import Button from 'components/base/Button';

/**
 * The "New Object" menu: a fixed set of folder-scoped create actions with their
 * display names, in alphabetical order. Each item renders only when its action
 * is present (ActionMenuItem null-guards absence), so authorization is handled
 * by the registry. A fixed child list rather than a computed map — the order is
 * authored (translation would reorder a sort, but not this).
 *
 * `folder` is the separate "New Folder" button; `report_definition` has no
 * create path; non-folder types (zone/user/role/worker/config) are excluded.
 */
export const WorkspaceNewObjectMenu = ({ actions }: { readonly actions: Actions }) => (
  <Dropdown>
    <Dropdown.Toggle as={Button} variant="phoenix-secondary" size="sm">
      New Object
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <ActionMenuItem actions={actions} action="createConnection" label="Connection" />
      <ActionMenuItem actions={actions} action="createEvent" label="Event" />
      <ActionMenuItem actions={actions} action="createIntegration" label="Integration" />
      <ActionMenuItem actions={actions} action="createLock" label="Lock" />
      <ActionMenuItem actions={actions} action="createDashboard" label="Monitoring Dashboard" />
      <ActionMenuItem actions={actions} action="createNodeDefinition" label="Node Definition" />
      <ActionMenuItem actions={actions} action="createPythonLibrary" label="Python Library" />
      <ActionMenuItem actions={actions} action="createQueue" label="Queue" />
      <ActionMenuItem actions={actions} action="createRecurrenceDefinition" label="Recurrence Definition" />
      <ActionMenuItem actions={actions} action="createSchedulingWindow" label="Scheduling Window" />
      <ActionMenuItem actions={actions} action="createTable" label="Table" />
      <ActionMenuItem actions={actions} action="createTrigger" label="Trigger" />
    </Dropdown.Menu>
  </Dropdown>
);
